import script from "./PastTradingDays.vue?vue&type=script&setup=true&lang=js"
export * from "./PastTradingDays.vue?vue&type=script&setup=true&lang=js"

import "./PastTradingDays.vue?vue&type=style&index=0&id=0067f563&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0067f563"]])

export default __exports__